(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["fn-editor-timer-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bl-navidad-countdown')) {
  customElements.define('bl-navidad-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.formatter = new Intl.DateTimeFormat('en-GB', {timeZone:'America/Montevideo',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.onResume = () => { if (!document.hidden) this.renderClock(); };
      document.addEventListener('visibilitychange', this.onResume);
      window.addEventListener('pageshow', this.onResume);
      this.renderClock();
      this.timer = window.setInterval(() => this.renderClock(), 1000);
    }
    secondsToMidnight(now) {
      const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
      return 86400 - (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second));
    }
    renderClock() {
      const remaining = this.secondsToMidnight(new Date());
      this.hours.textContent = String(Math.floor(remaining / 3600));
      this.minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2,'0');
      this.seconds.textContent = String(remaining % 60).padStart(2,'0');
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = null;
      document.removeEventListener('visibilitychange', this.onResume);
      window.removeEventListener('pageshow', this.onResume);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["fn-editor-video-runtime"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bl-fn-install-video'))customElements.define('bl-fn-install-video',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.video=this.querySelector('video');this.button=this.querySelector('button');this.userPaused=matchMedia('(prefers-reduced-motion:reduce)').matches;this.video.muted=true;
this.button.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.start()}else{this.userPaused=true;this.video.pause()}});
this.video.addEventListener('play',()=>this.sync());this.video.addEventListener('pause',()=>this.sync());
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible&&!this.userPaused)this.start();else if(!this.visible)this.video.pause()},{threshold:.15});this.observer.observe(this);
}
start(){if(!this.video.getAttribute('src')){this.video.src=this.video.dataset.src;this.video.load()}this.video.play().catch(()=>this.sync())}
sync(){const playing=!this.video.paused;this.button.setAttribute('aria-pressed',String(playing));this.button.setAttribute('aria-label',playing?'Pausar video de colocación':'Reproducir video de colocación');}
disconnectedCallback(){this.observer?.disconnect();this.video?.pause()}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kd-editor-timer-runtime"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bl-kit-diy-countdown')) {
  customElements.define('bl-kit-diy-countdown', class extends HTMLElement {
    connectedCallback() {
      if (this.timer) return;
      this.formatter = new Intl.DateTimeFormat('en-GB', {timeZone:'America/Montevideo',hour:'2-digit',minute:'2-digit',second:'2-digit',hourCycle:'h23'});
      this.hours = this.querySelector('[data-hours]');
      this.minutes = this.querySelector('[data-minutes]');
      this.seconds = this.querySelector('[data-seconds]');
      this.onResume = () => { if (!document.hidden) this.renderClock(); };
      document.addEventListener('visibilitychange', this.onResume);
      window.addEventListener('pageshow', this.onResume);
      this.renderClock();
      this.timer = window.setInterval(() => this.renderClock(), 1000);
    }
    secondsToMidnight(now) {
      const parts = Object.fromEntries(this.formatter.formatToParts(now).map(part => [part.type, part.value]));
      return 86400 - (Number(parts.hour) * 3600 + Number(parts.minute) * 60 + Number(parts.second));
    }
    renderClock() {
      const remaining = this.secondsToMidnight(new Date());
      this.hours.textContent = String(Math.floor(remaining / 3600));
      this.minutes.textContent = String(Math.floor(remaining % 3600 / 60)).padStart(2,'0');
      this.seconds.textContent = String(remaining % 60).padStart(2,'0');
    }
    disconnectedCallback() {
      window.clearInterval(this.timer);
      this.timer = null;
      document.removeEventListener('visibilitychange', this.onResume);
      window.removeEventListener('pageshow', this.onResume);
    }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["kd-editor-video-runtime"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('bl-kd-install-video'))customElements.define('bl-kd-install-video',class extends HTMLElement{
connectedCallback(){if(this.ready)return;this.ready=true;this.video=this.querySelector('video');this.button=this.querySelector('button');this.userPaused=matchMedia('(prefers-reduced-motion:reduce)').matches;this.video.muted=true;
this.button.addEventListener('click',()=>{if(this.video.paused){this.userPaused=false;this.start()}else{this.userPaused=true;this.video.pause()}});
this.video.addEventListener('play',()=>this.sync());this.video.addEventListener('pause',()=>this.sync());
this.observer=new IntersectionObserver(entries=>{this.visible=entries[0].isIntersecting;if(this.visible&&!this.userPaused)this.start();else if(!this.visible)this.video.pause()},{threshold:.15});this.observer.observe(this);
}
start(){if(!this.video.getAttribute('src')){this.video.src=this.video.dataset.src;this.video.load()}this.video.play().catch(()=>this.sync())}
sync(){const playing=!this.video.paused;this.button.setAttribute('aria-pressed',String(playing));this.button.setAttribute('aria-label',playing?'Pausar video de colocación':'Reproducir video de colocación');}
disconnectedCallback(){this.observer?.disconnect();this.video?.pause()}
});
  } catch(e) { console.error(e); }
})();

})();
